// Popular search scripts starts here

document.querySelectorAll('.popular-search li').forEach((item) => {
  item.addEventListener('click', () => {
    const keyword = item.textContent.trim();
    if (keyword) {
      const searchUrl = `/search?q=${encodeURIComponent(keyword)}`;
      window.location.href = searchUrl;
    }
  });
});

// search close on overlay click
document.addEventListener('DOMContentLoaded', () => {
  const searchButton = document.querySelector('.wt-header__search.wt-drawer-search');
  const closeButton = document.querySelector('.wt-header__search__close');
  const body = document.body;
  let isPopupOpen = false;

  if (searchButton && closeButton) {
    searchButton.addEventListener('click', (event) => {
      if (
        event.target.closest('.wt-header__search__form') ||
        event.target.closest('.wt-header__search__results')
      ) {
        return;
      }
      event.stopPropagation();
      event.preventDefault();
      if (!isPopupOpen) {
        isPopupOpen = true;
      } else if (
        isPopupOpen &&
        searchButton.classList.contains('wt-drawer-search--active') &&
        body.classList.contains('search-overlay-on')
      ) {
        if (closeButton) {
          closeButton.click();
          isPopupOpen = false;
        } else {
          console.error('Close button not found during click attempt');
        }
      } else {
        console.log('Conditions not met for closing popup');
      }
    });
  } else {
    console.error('Required elements not found:', {
      searchButton: !!searchButton,
      closeButton: !!closeButton,
    });
  }
});

// Popular search scripts ends here

document.addEventListener("DOMContentLoaded", function () {
  const addToCartForm = document.querySelector(".wt-product__add-to-cart_form.form");
  const installment = document.querySelector(".installment");
  const targetElement = addToCartForm || installment;
  if (targetElement) {
    const parent = targetElement.parentElement;
    const siblings = Array.from(parent.children);
    const hasVisibleSPBSibling = siblings.some(el =>
      el.id === "spb__notify-btn-container" &&
      window.getComputedStyle(el).display !== "none"
    );
    if (hasVisibleSPBSibling) {
      if (addToCartForm) {
        addToCartForm.style.display = "none";
      }
    }
  }
});

// scroll to next section starts

document.querySelector('.wt-logo-banner__additional__icon').addEventListener('click', function () {
  const nextSection = document.querySelector('main section');
  if (!nextSection) return;

  const targetPosition = nextSection.getBoundingClientRect().top + window.pageYOffset;
  const startPosition = window.pageYOffset;
  const distance = targetPosition - startPosition;
  const duration = 800;
  let start = null;

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function animation(currentTime) {
    if (start === null) start = currentTime;
    const timeElapsed = currentTime - start;
    const run = easeOutCubic(timeElapsed / duration) * distance + startPosition;
    window.scrollTo(0, run);
    if (timeElapsed < duration) requestAnimationFrame(animation);
  }

  requestAnimationFrame(animation);
});


// scroll to next section ends








